import { NgModule } from '@angular/core';
import { KebabCasePipe } from './kebab-case.pipe';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    KebabCasePipe
  ],
  exports: [
    KebabCasePipe
  ]
})
export class KebabCasePipeModule { }
